import { useEffect, useState } from "react";

const HEALTH_ENDPOINT = "/api/assistant/dashboard/chat/health/";

export interface VoiceInfo {
  voiceEnabled: boolean;
  ttsEnabled: boolean;
  ttsVoices: string[];
  ttsDefaultByLocale: Record<string, string>;
}

const EMPTY: VoiceInfo = { voiceEnabled: false, ttsEnabled: false, ttsVoices: [], ttsDefaultByLocale: {} };

// Module-level cache: stable for a session, fetch once.
let cached: VoiceInfo | null = null;

export function __resetVoiceEnabledCache(): void {
  cached = null;
}

export function useVoiceEnabled(): VoiceInfo {
  const [info, setInfo] = useState<VoiceInfo>(cached ?? EMPTY);

  useEffect(() => {
    if (cached !== null) {
      setInfo(cached);
      return;
    }
    let active = true;
    fetch(HEALTH_ENDPOINT)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!active) return;
        cached = {
          voiceEnabled: Boolean(d?.voice_enabled),
          ttsEnabled: Boolean(d?.tts_enabled),
          ttsVoices: Array.isArray(d?.tts_voices) ? d.tts_voices : [],
          ttsDefaultByLocale: d?.tts_default_voice_by_locale ?? {},
        };
        setInfo(cached);
      })
      .catch(() => {
        if (active) setInfo(EMPTY);
      });
    return () => {
      active = false;
    };
  }, []);

  return info;
}
